import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { ConfigFormRenderer } from "@/components/Form/ConfigFormRenderer";
import { NoxusFormEntryConfig } from "@/components/Spotflow/ConfigDrawer/ConfigDrawer";
import { FFService } from "@/services/FeatureFlags/FeatureFlags";

interface ToolConfigStepProps {
  itemConfig: Record<string, NoxusFormEntryConfig>;
  defaultValues: Record<string, unknown>;
  onChange: (values: Record<string, unknown>) => void;
  children?: React.ReactNode;
}

export const ToolConfigStep = ({
  itemConfig,
  defaultValues,
  onChange,
  children,
}: ToolConfigStepProps) => {
  const isToolApprovalsEnabled = FFService.getVar(
    "AGENT_TOOL_APPROVALS_ENABLED"
  );

  const filteredConfig = useMemo(() => {
    if (isToolApprovalsEnabled) return itemConfig;
    const { requires_approval, ...rest } = itemConfig;
    return rest;
  }, [itemConfig, isToolApprovalsEnabled]);

  const form = useForm({
    defaultValues,
  });

  useEffect(() => {
    const subscription = form.watch((_values, { type }) => {
      if (type === "change") {
        onChange(form.getValues() as Record<string, unknown>);
      }
    });
    return () => subscription.unsubscribe();
  }, [form, onChange]);

  return (
    <div className="w-full flex flex-col gap-6">
      {children}
      <ConfigFormRenderer
        config={filteredConfig}
        form={form}
        flattenAccordions
      />
    </div>
  );
};
